import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { AuthUser } from '@classes/auth/auth-user';
import { AppUser, InfosUser } from '@classes/auth/infosUser';
import { ClientSmartHub } from '@classes/client/client';
import { environment } from '@environments/environment';
import { faSitemap } from '@fortawesome/free-solid-svg-icons';

import { AuthService } from '@services/auth/auth.service';
import { ClientService } from '@services/client/client.service';
import { DataService } from '@services/data/data.service';
import { SubscriptionBaseComponent } from 'app/shared/subscription-base/subscription-base';
import { UserService } from '@services/user/user.service';

@Component({
  selector: 'app-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss'],
})
export class MainHeaderComponent
  extends SubscriptionBaseComponent
  implements OnInit, OnChanges {
  @Input() isAuth: boolean;
  @Output() sidenavToggle = new EventEmitter<void>();

  appName: string;
  logoApp: object;
  appVersion: string = environment.version;
  userAppSelected: any;
  isSuperAdmin: boolean;

  user: AuthUser;

  clients: ClientSmartHub[];
  clientForm: UntypedFormGroup;
  clientSelectedId: string;
  isLoadingClients = false;

  constructor(
    private authService: AuthService,
    private dataService: DataService,
    private clientService: ClientService,
    private fb: UntypedFormBuilder,
    private usersSrv: UserService
  ) {

    super();
  }

  ngOnInit(): void { }

  ngOnChanges(): void {
    if (this.isAuth) {
      this.userAppSelected = this.authService.getDecodedToken();
      this.user = this.authService.getUser();
      this.usersSrv.getCurrentUser().subscribe((user) => {
        if (user.client) {
          this.clientSelectedId = user.client.id;
          this.usersSrv.clientSelected = user.client.id;
        }
      });

      this.initSub();
      // this.userIsAdmin();
      if (this.userIsAdmin()) {
        this.isLoadingClients = true;
        this.getClients();
      }
    } else {
      this.user = null;
    }
  }

  onToggleSidenav(): void {
    this.sidenavToggle.emit();
  }

  private userIsAdmin(): boolean {
    let isAuth = false;

    for (const r of this.userAppSelected?.role) {
      isAuth = r.toLowerCase().search('superadmin') !== -1 ? true : false;
      if (isAuth) {
        break;
      }
    }

    return isAuth;
  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataService.appName.subscribe({
          next: (appName) => {
            this.appName = appName;
          },
        })
      )
      .add(
        this.dataService.logoApp.subscribe({
          next: (logoApp) => (this.logoApp = logoApp),
        })
      );
  }

  getClients() {
    this.clientService.getAllClients().subscribe((res) => {
      this.clients = res;
      this.isLoadingClients = false;
      this.initForm();
    });
  }

  private initForm(): void {
    let clientSelected: any = '';
    this.clients.map((client) => {
      if (client.id === this.clientSelectedId) {
        clientSelected = client;
      }
    });

    this.clientForm = this.fb.group({
      client: [clientSelected],
    });

    this.clientForm.get('client').valueChanges.subscribe((client) => {
      this.usersSrv.chooseClient(client).subscribe(() => {
        this.usersSrv.clientSelected = client.id;
      });
    });
  }
}
